import { ListItem } from "@mui/material";

import MultiSelectFilterV3 from "./MultiSelectFilterV3";

export default function CaseStatusFilter({
  selectedItems,
  setSelectedItems,
  setActiveItems,
  activeItems,
  resetPagination,
  setFilterState,
}) {
  const setSelectedState = (selectedValues) => {
    setSelectedItems(selectedValues);
    setFilterState({ fieldName: "caseStatusFilter", data: selectedValues });
  };

  return (
    <ListItem>
      <div className="w-full p-2 shadow">
        <MultiSelectFilterV3
          title="Filter by  Case Status"
          selectedItems={selectedItems}
          setSelectedItems={setSelectedState}
          setActiveItems={setActiveItems}
          activeItems={activeItems}
          nameKey="label"
          valueKey="key"
          resetPagination={resetPagination}
          searchTitle="Follow Ups"
          apiUrl={`/api/field_options/?content_type=case&field_name=overall_status&`}
          buttonFullW={true}
          dropdown={false}
          filterName={"caseStatusFilter"}
          setFilterState={setFilterState}
        />
      </div>
    </ListItem>
  );
}
